import responseHandler from "../system/server-response-handler";
import { postRequest, formDataPostRequest } from "../system/server-calls";
import { API_STATUS } from "../constants";
import {
  clearStorage,
  setItemToStorage,
  removeItemFromStorage,
} from "../system/storage";
import { encryptObject } from "../system/encryption";

const logout = () => {
  removeItemFromStorage(process.env.REACT_APP_PAYLOAD);
  clearStorage();
  window.location.reload();
  return Promise.resolve();
};

// handling the Login response, if user is authenticated then saving
// the jwt token in the local storage
const handleLoginResponse = (response) => {
  const { statusCode } = response.data;
  if (statusCode !== API_STATUS.SUCCESS) {
    logout();
    return responseHandler.handleServerResponse(response);
  }
  const ciphertext = encryptObject({
    ...response.data.payload,
  });
  setItemToStorage(process.env.REACT_APP_PAYLOAD, ciphertext);

  return response.data.payload;
};

const login = (data) => {
  return postRequest("Auth/Login", data).then(
    (response) => handleLoginResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const register = (data) => {
  return postRequest("User/Signup", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const forgotPasswordSendEmail = (data) => {
  return postRequest("Auth/ForgotPassword", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const resetPassword = (data) => {
  return postRequest("Auth/ResetPassword", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const verifyEmail = (body) =>
  postRequest("Auth/VerifyEmail", body, false).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const agentRegisteration = (data) => {
  return formDataPostRequest("Agent/Create", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const authService = {
  resetPassword,
  forgotPasswordSendEmail,
  login,
  logout,
  register,
  agentRegisteration,
  verifyEmail,
};
